import { render, staticRenderFns } from "./Workout.vue?vue&type=template&id=b0815312&scoped=true"
import script from "./Workout.vue?vue&type=script&lang=js"
export * from "./Workout.vue?vue&type=script&lang=js"
import style0 from "./Workout.vue?vue&type=style&index=0&id=b0815312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0815312",
  null
  
)

export default component.exports